// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Colors */
  --color-background: #000000;
  --color-text: #ffffff;
  --color-text-subtle: #999;

  /* Typography */
  --font-family: -apple-system, Helvetica, sans-serif;
  --font-size-base: clamp(16px, 1.6vw, 18px);
  --font-size-small: clamp(14px, 1.4vw, 16px);
  --font-size-medium: clamp(18px, 2vw, 24px);
  --font-size-large: clamp(24px, 3vw, 36px);
  --font-size-xlarge: clamp(28px, 3.5vw, 42px);
  --font-size-xxlarge: clamp(32px, 4vw, 48px);
  --line-height-base: 1.5;
  --font-weight-normal: 400;
  --font-weight-bold: 700;

  /* Spacing */
  --space-xxs: clamp(0.25rem, 0.5vw, 0.5rem);
  --space-xs: clamp(0.5rem, 1vw, 1rem);
  --space-sm: clamp(1rem, 1.5vw, 1.5rem);
  --space-md: clamp(1.5rem, 2vw, 2rem);
  --space-lg: clamp(2rem, 3vw, 3rem);
  --space-xl: clamp(3rem, 4vw, 4rem);
  --space-xxl: clamp(6rem, 7vw, 7rem);

  /* Layout */
  --content-padding: var(--space-md);
  --content-width: 1200px;

  /* Transitions */
  --transition-speed: 150ms;

  --carousel-height: 700px;
}

/* Link styles */
a {
  color: rgba(255, 255, 255, 0.87); /* Same white as text */
  text-decoration: underline;
  text-decoration-color: rgba(255, 255, 255, 0.87); /* Underlined in white */
  transition: color 0.3s ease, text-decoration-color 0.3s ease;
}

a:hover,
a:focus {
  color: rgba(255, 255, 255, 1); /* Ensure color stays white on hover/focus */
  text-decoration-color: rgba(255, 255, 255, 1); /* Underline remains white */
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  background-color: var(--color-background);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size-base);
  line-height: var(--line-height-base);
  scrollbar-width: none;
  -ms-overflow-style: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0;
  height: 0;
}

body > #root {
  width: 95vw;
  /* make the root be always centered within the body */
  margin: auto;
}

body.custom-scrollbar-dragging {
  -webkit-user-select: none;
          user-select: none;
}

main {
  transition: filter 0.5s ease, transform 0.3s ease;
  margin-bottom: 8rem;
}

main.blur {
  filter: blur(25px);
}

body.submenu-open .content-wrapper,
body.submenu-open main {
  transform: translateY(50px);
  transition: transform 0.6s ease;
  transition-delay: 0.15s; /* Add a slight delay */
}

.content-wrapper,
main {
  transition: transform 0.3s ease;
  transition-delay: 0s; /* No delay when closing */
}

.content {
  width: min(100%, var(--content-width));
  margin: 0 auto;
}

/* Responsive typography */
h1 {
  font-size: var(--font-size-xlarge);
  text-wrap: balance;
}
h2 {
  font-size: var(--font-size-large);
  text-wrap: balance;
}
h3 {
  font-size: var(--font-size-medium);
  text-wrap: balance;
}
p {
  font-size: var(--font-size-base);
  text-wrap: balance;
}

h4,
h5,
h6,
li,
figcaption,
blockquote {
  text-wrap: balance;
}

/* Utility classes */
.text-center {
  text-align: center;
}
.mb-sm {
  margin-bottom: var(--space-sm);
}
.mb-md {
  margin-bottom: var(--space-md);
}
.mb-lg {
  margin-bottom: var(--space-lg);
}

.accent-underline {
  position: relative;
  display: inline-block;
}

.accent-underline::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -0.18em;
  width: 100%;
  height: 3px;
  background: #4da3ff;
  transform: scaleX(0);
  transform-origin: left center;
  animation: accentUnderlineReveal 0.7s ease 0.2s forwards;
}

@keyframes accentUnderlineReveal {
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
}

/* Button styles */
.button {
  display: inline-block;
  padding: var(--space-xs) var(--space-sm);
  background-color: var(--color-text);
  color: var(--color-background);
  text-decoration: none;
  font-size: var(--font-size-small);
  border-radius: 25px;
  border: none;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.button:hover {
  transform: scale(1.05);
  background-color: var(--color-text-subtle);
}

/* Add this to your existing CSS file */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  opacity: 0;
  animation: fadeIn 0.5s forwards;
}

.fade-in.visible {
  opacity: 1;
}

/* src/App.css */

/* Define the fade-enter and fade-exit animations */
.fade-enter {
  opacity: 0;
  transform: translateY(20px);
}
.fade-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 300ms, transform 300ms;
}
.fade-exit {
  opacity: 1;
  transform: translateY(0);
}
.fade-exit-active {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 300ms, transform 300ms;
}

/* Optional: Adjust the body and root element to avoid background flashes */
/* src/App.css */

body,
html,
#root {
  background-color: var(--color-background);
  color: var(--color-text);
  height: 100%;
  margin: 0;
}

.MuiSvgIcon-root {
  /* controls the hamburger icon on mobile */
  color: rgba(255, 255, 255, 0.87);
  /* push it a couple pixels to the top */
  margin-top: -35px;
}

@media (prefers-reduced-motion: reduce) {
  .accent-underline::after {
    animation: none;
    transform: scaleX(1);
  }
}

@media (max-width: 768px) {
  /* Custom Drawer Styles */
  .MuiDrawer-paper {
    margin-top: var(--space-xl);
    background-color: rgba(0, 0, 0, 0) !important;
    box-shadow: none !important;
    color: rgba(255, 255, 255, 0.87) !important;
    width: 100% !important;
    z-index: 1300;
  }

  /* Main menu items */
  .MuiList-root > .MuiListItem-root {
    color: rgb(255, 255, 255) !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
    transition: background-color 0.3s ease;
  }

  .MuiTypography-root {
    font-size: 1.65rem !important;
  }

  .MuiList-root > .MuiListItem-root .MuiListItemText-primary {
    font-size: 1.65rem !important;
    color: rgb(255, 255, 255) !important;
    padding-left: 18px !important;
  }

  /* Submenu group */
  .MuiCollapse-root {
    margin-bottom: 20px !important; /* Add space after each submenu group */
  }

  /* Submenu headings */
  .MuiListSubheader-root {
    color: rgba(200, 200, 200, 0.87) !important;
    font-weight: var(--font-weight-normal) !important;
    background-color: rgba(0, 0, 0, 0) !important;
    font-size: 18px !important;
    padding: 0px 0 0px 22px !important;
    margin-top: 12px !important; /* Add some space above each submenu heading */
  }

  /* Submenu items */
  .MuiCollapse-root .css-bshv44-MuiButtonBase-root-MuiListItem-root {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .MuiCollapse-root .MuiListItem-root {
    padding-left: 4px !important;
  }

  .MuiCollapse-root .MuiListItem-root .MuiListItemText-primary {
    font-size: 18px !important;
    color: rgba(238, 238, 238, 0.87) !important;
    padding-left: 22px !important; /* Align with submenu heading */
  }

  .MuiListItem-root:hover {
    background-color: rgba(0, 0, 0, 0) !important;
  }

  .MuiListItemIcon-root {
    color: rgb(238, 238, 238) !important;
    min-width: 32px !important;
  }

  /* Specific styles for links within the drawer */
  .MuiDrawer-paper a {
    text-decoration: none;
  }

  .MuiDrawer-paper a:hover {
    text-decoration: none;
  }

  /* Blur effect for the rest of the page */
  .body-blur .content-wrapper,
  .body-blur main {
    filter: blur(25px);
    transition: filter 0.3s ease;
  }

  body.mobile-menu-open .content-wrapper,
  body.mobile-menu-open main {
    transform: translateY(25px);
    transition: transform 0.6s ease;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;;EAEzB,eAAe;EACf,mDAAmD;EACnD,0CAA0C;EAC1C,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;EACzC,4CAA4C;EAC5C,2CAA2C;EAC3C,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;;EAEvB,YAAY;EACZ,0CAA0C;EAC1C,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;EACpC,kCAAkC;EAClC,kCAAkC;EAClC,mCAAmC;;EAEnC,WAAW;EACX,kCAAkC;EAClC,uBAAuB;;EAEvB,gBAAgB;EAChB,yBAAyB;;EAEzB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,gCAAgC,EAAE,uBAAuB;EACzD,0BAA0B;EAC1B,gDAAgD,EAAE,wBAAwB;EAC1E,4DAA4D;AAC9D;;AAEA;;EAEE,6BAA6B,EAAE,4CAA4C;EAC3E,6CAA6C,EAAE,4BAA4B;AAC7E;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,yCAAyC;EACzC,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;EAChC,oCAAoC;EACpC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;EAEE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB,EAAE,uBAAuB;AAClD;;AAEA;;EAEE,+BAA+B;EAC/B,oBAAoB,EAAE,0BAA0B;AAClD;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,wDAAwD;AAC1D;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,wCAAwC;EACxC,mCAAmC;EACnC,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,uCAAuC;AACvC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;;AAEhB,mDAAmD;AACnD;EACE,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,2EAA2E;AAC3E,gBAAgB;;AAEhB;;;EAGE,yCAAyC;EACzC,wBAAwB;EACxB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA;EACE,yBAAyB;EACzB;IACE,2BAA2B;IAC3B,6CAA6C;IAC7C,2BAA2B;IAC3B,2CAA2C;IAC3C,sBAAsB;IACtB,aAAa;EACf;;EAEA,oBAAoB;EACpB;IACE,oCAAoC;IACpC,4BAA4B;IAC5B,6BAA6B;IAC7B,sCAAsC;EACxC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA,kBAAkB;EAClB;IACE,8BAA8B,EAAE,uCAAuC;EACzE;;EAEA,qBAAqB;EACrB;IACE,2CAA2C;IAC3C,iDAAiD;IACjD,6CAA6C;IAC7C,0BAA0B;IAC1B,kCAAkC;IAClC,2BAA2B,EAAE,8CAA8C;EAC7E;;EAEA,kBAAkB;EAClB;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2CAA2C;IAC3C,6BAA6B,EAAE,+BAA+B;EAChE;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;;EAEA,gDAAgD;EAChD;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA,yCAAyC;EACzC;;IAEE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;AACF","sourcesContent":[":root {\n  /* Colors */\n  --color-background: #000000;\n  --color-text: #ffffff;\n  --color-text-subtle: #999;\n\n  /* Typography */\n  --font-family: -apple-system, Helvetica, sans-serif;\n  --font-size-base: clamp(16px, 1.6vw, 18px);\n  --font-size-small: clamp(14px, 1.4vw, 16px);\n  --font-size-medium: clamp(18px, 2vw, 24px);\n  --font-size-large: clamp(24px, 3vw, 36px);\n  --font-size-xlarge: clamp(28px, 3.5vw, 42px);\n  --font-size-xxlarge: clamp(32px, 4vw, 48px);\n  --line-height-base: 1.5;\n  --font-weight-normal: 400;\n  --font-weight-bold: 700;\n\n  /* Spacing */\n  --space-xxs: clamp(0.25rem, 0.5vw, 0.5rem);\n  --space-xs: clamp(0.5rem, 1vw, 1rem);\n  --space-sm: clamp(1rem, 1.5vw, 1.5rem);\n  --space-md: clamp(1.5rem, 2vw, 2rem);\n  --space-lg: clamp(2rem, 3vw, 3rem);\n  --space-xl: clamp(3rem, 4vw, 4rem);\n  --space-xxl: clamp(6rem, 7vw, 7rem);\n\n  /* Layout */\n  --content-padding: var(--space-md);\n  --content-width: 1200px;\n\n  /* Transitions */\n  --transition-speed: 150ms;\n\n  --carousel-height: 700px;\n}\n\n/* Link styles */\na {\n  color: rgba(255, 255, 255, 0.87); /* Same white as text */\n  text-decoration: underline;\n  text-decoration-color: rgba(255, 255, 255, 0.87); /* Underlined in white */\n  transition: color 0.3s ease, text-decoration-color 0.3s ease;\n}\n\na:hover,\na:focus {\n  color: rgba(255, 255, 255, 1); /* Ensure color stays white on hover/focus */\n  text-decoration-color: rgba(255, 255, 255, 1); /* Underline remains white */\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  background-color: var(--color-background);\n  color: var(--color-text);\n  font-family: var(--font-family);\n  font-size: var(--font-size-base);\n  line-height: var(--line-height-base);\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\nhtml::-webkit-scrollbar,\nbody::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\nbody > #root {\n  width: 95vw;\n  /* make the root be always centered within the body */\n  margin: auto;\n}\n\nbody.custom-scrollbar-dragging {\n  user-select: none;\n}\n\nmain {\n  transition: filter 0.5s ease, transform 0.3s ease;\n  margin-bottom: 8rem;\n}\n\nmain.blur {\n  filter: blur(25px);\n}\n\nbody.submenu-open .content-wrapper,\nbody.submenu-open main {\n  transform: translateY(50px);\n  transition: transform 0.6s ease;\n  transition-delay: 0.15s; /* Add a slight delay */\n}\n\n.content-wrapper,\nmain {\n  transition: transform 0.3s ease;\n  transition-delay: 0s; /* No delay when closing */\n}\n\n.content {\n  width: min(100%, var(--content-width));\n  margin: 0 auto;\n}\n\n/* Responsive typography */\nh1 {\n  font-size: var(--font-size-xlarge);\n  text-wrap: balance;\n}\nh2 {\n  font-size: var(--font-size-large);\n  text-wrap: balance;\n}\nh3 {\n  font-size: var(--font-size-medium);\n  text-wrap: balance;\n}\np {\n  font-size: var(--font-size-base);\n  text-wrap: balance;\n}\n\nh4,\nh5,\nh6,\nli,\nfigcaption,\nblockquote {\n  text-wrap: balance;\n}\n\n/* Utility classes */\n.text-center {\n  text-align: center;\n}\n.mb-sm {\n  margin-bottom: var(--space-sm);\n}\n.mb-md {\n  margin-bottom: var(--space-md);\n}\n.mb-lg {\n  margin-bottom: var(--space-lg);\n}\n\n.accent-underline {\n  position: relative;\n  display: inline-block;\n}\n\n.accent-underline::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -0.18em;\n  width: 100%;\n  height: 3px;\n  background: #4da3ff;\n  transform: scaleX(0);\n  transform-origin: left center;\n  animation: accentUnderlineReveal 0.7s ease 0.2s forwards;\n}\n\n@keyframes accentUnderlineReveal {\n  from {\n    transform: scaleX(0);\n  }\n\n  to {\n    transform: scaleX(1);\n  }\n}\n\n/* Button styles */\n.button {\n  display: inline-block;\n  padding: var(--space-xs) var(--space-sm);\n  background-color: var(--color-text);\n  color: var(--color-background);\n  text-decoration: none;\n  font-size: var(--font-size-small);\n  border-radius: 25px;\n  border: none;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.button:hover {\n  transform: scale(1.05);\n  background-color: var(--color-text-subtle);\n}\n\n/* Add this to your existing CSS file */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  opacity: 0;\n  animation: fadeIn 0.5s forwards;\n}\n\n.fade-in.visible {\n  opacity: 1;\n}\n\n/* src/App.css */\n\n/* Define the fade-enter and fade-exit animations */\n.fade-enter {\n  opacity: 0;\n  transform: translateY(20px);\n}\n.fade-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.fade-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n.fade-exit-active {\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 300ms, transform 300ms;\n}\n\n/* Optional: Adjust the body and root element to avoid background flashes */\n/* src/App.css */\n\nbody,\nhtml,\n#root {\n  background-color: var(--color-background);\n  color: var(--color-text);\n  height: 100%;\n  margin: 0;\n}\n\n.MuiSvgIcon-root {\n  /* controls the hamburger icon on mobile */\n  color: rgba(255, 255, 255, 0.87);\n  /* push it a couple pixels to the top */\n  margin-top: -35px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .accent-underline::after {\n    animation: none;\n    transform: scaleX(1);\n  }\n}\n\n@media (max-width: 768px) {\n  /* Custom Drawer Styles */\n  .MuiDrawer-paper {\n    margin-top: var(--space-xl);\n    background-color: rgba(0, 0, 0, 0) !important;\n    box-shadow: none !important;\n    color: rgba(255, 255, 255, 0.87) !important;\n    width: 100% !important;\n    z-index: 1300;\n  }\n\n  /* Main menu items */\n  .MuiList-root > .MuiListItem-root {\n    color: rgb(255, 255, 255) !important;\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n    transition: background-color 0.3s ease;\n  }\n\n  .MuiTypography-root {\n    font-size: 1.65rem !important;\n  }\n\n  .MuiList-root > .MuiListItem-root .MuiListItemText-primary {\n    font-size: 1.65rem !important;\n    color: rgb(255, 255, 255) !important;\n    padding-left: 18px !important;\n  }\n\n  /* Submenu group */\n  .MuiCollapse-root {\n    margin-bottom: 20px !important; /* Add space after each submenu group */\n  }\n\n  /* Submenu headings */\n  .MuiListSubheader-root {\n    color: rgba(200, 200, 200, 0.87) !important;\n    font-weight: var(--font-weight-normal) !important;\n    background-color: rgba(0, 0, 0, 0) !important;\n    font-size: 18px !important;\n    padding: 0px 0 0px 22px !important;\n    margin-top: 12px !important; /* Add some space above each submenu heading */\n  }\n\n  /* Submenu items */\n  .MuiCollapse-root .css-bshv44-MuiButtonBase-root-MuiListItem-root {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .MuiCollapse-root .MuiListItem-root {\n    padding-left: 4px !important;\n  }\n\n  .MuiCollapse-root .MuiListItem-root .MuiListItemText-primary {\n    font-size: 18px !important;\n    color: rgba(238, 238, 238, 0.87) !important;\n    padding-left: 22px !important; /* Align with submenu heading */\n  }\n\n  .MuiListItem-root:hover {\n    background-color: rgba(0, 0, 0, 0) !important;\n  }\n\n  .MuiListItemIcon-root {\n    color: rgb(238, 238, 238) !important;\n    min-width: 32px !important;\n  }\n\n  /* Specific styles for links within the drawer */\n  .MuiDrawer-paper a {\n    text-decoration: none;\n  }\n\n  .MuiDrawer-paper a:hover {\n    text-decoration: none;\n  }\n\n  /* Blur effect for the rest of the page */\n  .body-blur .content-wrapper,\n  .body-blur main {\n    filter: blur(25px);\n    transition: filter 0.3s ease;\n  }\n\n  body.mobile-menu-open .content-wrapper,\n  body.mobile-menu-open main {\n    transform: translateY(25px);\n    transition: transform 0.6s ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
